import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { useTranslation } from 'react-i18next';

export interface ChargePointChannelOcppStatusFilterStateControllerProps {
  value: GatewayChargePointModel['channels'][number]['computedStatus'];
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointChannelOcppStatusFilterStateController = ({
  value,
  onRemove,
}: ChargePointChannelOcppStatusFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="wire"
      label={t(`delmonicos-shared-sdk.ocpp-enums-charge-point-status.${value}`)}
      onRemove={onRemove}
    />
  );
};
